import { Theme } from '@mui/material';

import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

export const useMailValidationStyles = makeStyles((theme: Theme) =>
  createStyles({
    content: {
      width: '600px',
      height: '600px',
      [theme.breakpoints.down('sm')]: {
        width: 'auto',
      },
    },
    root: {
      display: 'flex',
      justifyContent: 'center',
      paddingTop: '15px',
      [theme.breakpoints.down('sm')]: {
        paddingTop: '20px',
        paddingLeft: '39.5px',
        paddingRight: '28.5px',
      },
    },
    centerContent: {
      width: '500px',
    },
    spinner: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      '& :first-child': {
        marginBottom: '5px',
      },
    },
  })
);
